import { useEffect, useState } from 'react';

const query = '(max-width: 599px)';

/** Phone-width layout (the ChatGPT app flow: email first, round back button, centered logo). */
const useNarrow = () => {
  const [narrow, setNarrow] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => {
      setNarrow(media.matches);
    };
    media.addEventListener('change', update);
    return () => {
      media.removeEventListener('change', update);
    };
  }, []);

  return narrow;
};

export default useNarrow;
